<template>
  <v-sheet :width="'100%'" :elevation="4">
    <v-container>
      <p>Texts:</p>
      <TextsContainer :messages="messages" />
      <TextForm class="mt-5" />
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import TextsContainer from "@/components/messages/text/TextsContainer";
import TextForm from "@/components/messages/text/TextForm";

export default {
  name: "TextTab",
  components: {
    TextsContainer,
    TextForm,
  },
  created() {
    this.sockets.subscribe("ADD_MESSAGE", () => {});
    this.sockets.subscribe("UPDATE_SEND_STATUS", () => {});
  },
  computed: {
    ...mapGetters({
      messages: "messages/messages",
    }),
  },
};
</script>

<style>
</style>